import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store'
import begin from '@/views/begin';
import home from '@/views/home';
import appuntamenti from '@/views/appuntamenti';
import profilo from '@/views/profilo';
import notifiche from '@/views/notifiche';
import faq from '@/views/faq';
import imieipacchetti from '@/views/imieipacchetti';
import supportMeeting from '@/views/supportMeeting';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/maintenance',
        name: 'maintenance',
        component: () => import("../views/maintenance/Maintenance.vue"),
    },
    ...begin.routes(),
    {
        path: '/',
        component: () => import("../views/layout/layout.vue"),
        children: [
            ...home.routes(),
            ...appuntamenti.routes(),
            ...profilo.routes(),
            ...notifiche.routes(),
            ...imieipacchetti.routes(),
            ...faq.routes(),
            ...supportMeeting.routes()
        ]
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        window.scrollTo(savedPosition ? savedPosition.left : 0, savedPosition ? savedPosition.top : 0);
    }
})


router.beforeEach((to, from, next) => {
    if (store.state.maintenance && to.name !== 'maintenance') {
        next('/maintenance');
        return;
    }

    const userRole = store.state.user && store.state.user.role
        ? store.state.user.role.toString().toLowerCase()
        : '';
    const isFamilyUser = userRole.indexOf('family') !== -1;
    const restrictedForFamily = ['/academy', '/webinar'];

    if (isFamilyUser && restrictedForFamily.some(prefix => to.path.startsWith(prefix))) {
        next('/atupertu');
        store.state.beforeNavCbs = [];
        return;
    }

    if(store.state.beforeNavCbs.length == 0){
        next();
        return;
    }
    store.state.beforeNavCbs.forEach(x => {
        x(to, from, next);
    });
    store.state.beforeNavCbs = [];
})

router.afterEach((to, from) => {
    store.state.afterNavCbs.forEach(x => {
        x(to, from);
    });
    store.state.afterNavCbs = [];
})

export default router
